import { Toolbar, makeStyles } from "@material-ui/core";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { Box, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import React, { useMemo } from "react";
import { AppBar, LoadingIndicator, usePermissions } from "react-admin";
import { useLocation } from "react-router-dom";

import { envSettings } from "core/EnvSettings";
import { UserRole } from "entities/UserRole";
import { useSocketLogic } from "../hooks/useAppBarLogic";
import { DashboardPorts } from "./DashboardPorts/DashboardPorts";
import { MyUserMenu } from "./UserMenu";
import { SPPScannerControl } from "../components/Scanner/GlobalSPPScanner";

const useStyles = makeStyles((theme) => ({
	appBar: {
		// to disable default refresh button on AppBar rigth side
		"& .MuiToolbar-root.MuiToolbar-dense": {
			display: "flex !important",
			flexDirection: "row !important",
			justifyContent: "space-between !important",
			alignItems: "center !important",
			minHeight: "64px !important",
			paddingRight: "24px !important",
			// paddingTop: "5px !important",
			paddingBottom: "5px !important",
			"& > *:last-child": {
				display: "none !important",
			},
		},
	},
	toolbar: {
		paddingRight: 24,
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		width: "100%",
	},
	leftSection: {
		flex: "0 0 auto",
		display: "flex",
		alignItems: "center",
	},
	rightSection: {
		flex: "0 0 auto",
		display: "flex",
		alignItems: "center",
		marginLeft: "auto", // This ensures it sticks to the right
	},
	title: {
		marginLeft: 0,
	},
	prodBanner: {
		borderRadius: 0,
		color: theme.palette.text.primary,
		backgroundColor: "transparent",
		boxShadow: "none",
		"& .MuiAlert-message": {
			width: "100%",
			textAlign: "center",
			fontSize: 12,
			fontWeight: 600,
			letterSpacing: 0.4,
		},
		"& .MuiAlert-icon": {
			color: fade(theme.palette.warning.dark, 0.7),
		},
	},
}));

export const UserEmail = () => {
	const { permissions } = usePermissions();

	if (!permissions) return null;

	return <Typography variant="body2">{permissions.email}</Typography>;
};

export const MyAppBar = (props) => {
	const classes = useStyles();
	const location = useLocation();
	const { permissions } = usePermissions();

	useSocketLogic();

	const currentPath = useMemo(
		() => (location.pathname.startsWith("/") ? location.pathname.slice(1) : location.pathname),
		[location.pathname]
	);

	const isOrdersGridPath = currentPath === "orders";
	const isAdmin = permissions && permissions.role === UserRole.admin;

	return (
		<AppBar
			{...props}
			className={classes.appBar}
			userMenu={false} // Hide default user menu
			position="static"
		>
			<Toolbar className={classes.toolbar}>
				<div className={classes.leftSection}>
					<Typography
						variant="h6"
						color="inherit"
						id="react-admin-title"
						className={classes.title}
					/>
				</div>
				{/* To access orders grid filters */}
				{isOrdersGridPath && (
					<DashboardPorts />
				)}
				<div className={classes.rightSection}>
					<SPPScannerControl />
					<LoadingIndicator />
					<MyUserMenu {...props} />
				</div>
			</Toolbar>
			{isAdmin && envSettings.REACT_APP_IS_PROD && envSettings.REACT_APP_FF_DEVS_ATTENTION_ALERT && (
				<Box>
					<Alert severity="warning" variant="standard" className={classes.prodBanner}>
						<span>
							ATTENTION!
							<br />
							Prod server
						</span>
					</Alert>
				</Box>
			)}
		</AppBar>
	);
};
